module.exports = __webpack_public_path__ + "917c66e3d18b20805d477db6dd83a0f9.fbx";